import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-table-select',
  templateUrl: './table-select.component.html',
  styleUrls: ['./table-select.component.scss'],
})
export class TableSelectComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams & { selectedId: BehaviorSubject<number> };
  public selectedId!: BehaviorSubject<number>;
  public disabled: boolean = true;

  get options(){
    let colName = this.params.colDef?.field;
    return colName ?  this.params.context?.componentParent?.config?.[colName] : [];
  }

  constructor() {}

  agInit(params: ICellRendererParams & { selectedId: BehaviorSubject<number>; options: any }): void {
    this.params = params;
    this.selectedId = params.selectedId;
  }

  refresh(params: ICellRendererParams & { selectedId: BehaviorSubject<number> }): boolean {
    return false;
  }

  onSelected(value: string) {
    this.params.context.componentParent.cellMethodSelect(value);
  }
}
